<template>
  <app-modal
    modal-alignment="top"
    modal-id="deal-modal"
    modal-size="extra-large"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 v-if="selectedUrl" class="modal-title">{{ $t("edit_deal") }}</h5>
      <h5 v-else class="modal-title">{{ $t("add_deal") }}</h5>
      <button
        aria-label="Close"
        class="close outline-none"
        @click.prevent="closeModal"
        type="button"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form
        v-if="dataLoaded"
        ref="form"
        :data-url="selectedUrl ? selectedUrl : route('deals.store')"
      >
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            {{ $t("title") }}
          </label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.title"
              :placeholder="$t('enter_deal_title')"
              type="text"
              :error-message="$errorMessage(errors, 'title')"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            {{ $t("description") }}
          </label>
          <div class="col-sm-9">
            <app-input
              type="markdown"
              v-model="formData.description"
              :placeholder="$t('enter_description')"
            />
          </div>
        </div>

        <template v-if="componentType == 'deal'">
          <div class="form-group row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">
              {{ $t("lead_type") }}</label
            >
            <div class="col-sm-9">
              <app-input
                v-model="formData.lead_type"
                :list="[
                  { id: 1, value: $t('person') },
                  { id: 2, value: $t('organization') },
                ]"
                type="radio"
                @change="changeLeadType"
                :error-message="$errorMessage(errors, 'lead_type')"
              />
            </div>
          </div>
        </template>

        <template v-if="formData.lead_type == 1 && componentType == 'deal'">
          <div class="form-group row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">
              {{ $t("person") }}
            </label>
<!--              old-->
<!--            <div class="col-sm-9">-->
<!--              <app-input-->
<!--                v-model="formData.contextable_id"-->
<!--                :list="personList"-->
<!--                :placeholder="$t('choose_a_contact_person')"-->
<!--                list-value-field="name"-->
<!--                type="search-select"-->
<!--                :error-message="$errorMessage(errors, 'contextable_id')"-->
<!--              />-->
<!--            </div>-->

            <div class="col-sm-9" :key="renderContextableInput">
              <app-input
                v-model="formData.contextable_id"
                :options="personsOptions"
                :placeholder="$t('choose_a_contact_person')"
                type="search-and-select"
                :error-message="$errorMessage(errors, 'contextable_id')"
              />
            </div>
          </div>
        </template>

        <template v-else>
          <template v-if="componentType != 'person'">
            <template v-if="componentType != 'org'">
              <div class="form-group row">
                <label class="mb-0 col-sm-3 d-flex align-items-center">
                  {{ $t("organization") }}</label
                >
                <div class="col-sm-9" :key="renderContextableInput">
<!--                    old-->
<!--                  <app-input-->
<!--                    v-model="formData.contextable_id"-->
<!--                    :list="organizationList"-->
<!--                    :placeholder="$t('choose_an_organization')"-->
<!--                    list-value-field="name"-->
<!--                    type="search-select"-->
<!--                    :error-message="$errorMessage(errors, 'contextable_id')"-->
<!--                  />-->
                  <app-input
                    v-model="formData.contextable_id"
                    :options="organizationOptions"
                    :placeholder="$t('choose_an_organization')"
                    type="search-and-select"
                    @input="handleOrgPersonChange"
                    :error-message="$errorMessage(errors, 'contextable_id')"
                  />
                </div>
              </div>
            </template>
            <div class="form-group row" v-if="formData.contextable_id">
              <label class="mb-0 col-sm-3 d-flex align-items-center">
                {{ $t("contact_person")  }}
              </label>
              <div class="col-sm-9">
<!--                  old -->
<!--                <app-input-->
<!--                  v-model="formData.person_id"-->
<!--                  :list="personListAsOrg"-->
<!--                  :placeholder="$t('choose_a_contact_person')"-->
<!--                  list-value-field="name"-->
<!--                  type="search-select"-->
<!--                />-->

                    <template v-if="formData.contextable_id">
                        <app-input
                            :key="formData.contextable_id"
                            v-model="formData.person_id"
                            :options="personListAsOrgOptios"
                            :placeholder="$t('choose_a_contact_person')"
                            type="search-and-select"
                            @list-change="handleListChange"
                        />
                    </template>

<!--                  old-->
<!--                <small-->
<!--                  class="text-danger col-sm-9 pl-0 mb-0"-->
<!--                  v-if="formData.contextable_id && personListAsOrg.length < 1"-->
<!--                >-->
                <small
                  class="text-danger col-sm-9 pl-0 mb-0"
                  v-if="formData.contextable_id && contactPersonListLength < 1"
                >
                  {{ $t("organization_has_no_contact_person") }}
                </small>
              </div>
            </div>
          </template>
        </template>

        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">{{
            $t("deal_value")
          }}</label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.value"
              :placeholder="$t('enter_deal_value')"
              type="number"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">{{
            $t("pipeline")
          }}</label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.pipeline_id"
              :list="pipelineList"
              :required="true"
              type="select"
              :error-message="$errorMessage(errors, 'pipeline_id')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">{{
            $t("stages")
          }}</label>
          <div class="col-sm-9">
            <component
              :is="'app-step-input-selector'"
              v-if="pipelineChange"
              v-model="formData.stage_id"
              :required="true"
              :step-complete="stageIndexAsId"
              :show-label="true"
              :step-lists="stageListAsPipelineId"
              @stepChanges="setStageId"
              :error-message="$errorMessage(errors, 'stage_id')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">{{
            $t("expecting_closing_date")
          }}</label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.expired_at"
              :placeholder="$t('choose_a_date')"
              :popover-position="'top-start'"
              type="date"
              :error-message="$errorMessage(errors, 'expired_at')"
            />
          </div>
        </div>
        <div class="form-group row" v-if="$can('manage_public_access')">
          <label class="mb-0 col-sm-3 d-flex align-items-center">{{ $t("owner") }}</label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.owner_id"
              :list="ownerList"
              list-value-field="full_name"
              type="select"
            />
          </div>
        </div>
        <template v-if="customFields.length && customFieldDataLoaded">
          <div v-for="(field, index) in customFields" :key="index" class="form-group row">
            <div class="col-md-3">
              <label>{{ field.name }}</label>
            </div>
            <div class="col-md-9">
              <template v-if="field.custom_field_type.name === 'text'">
                <app-input
                  :id="field.name"
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  type="text"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'textarea'">
                <app-input
                  :id="field.name"
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  type="textarea"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'radio'">
                <app-input
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  :radio-checkbox-name="field.name"
                  type="radio"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'checkbox'">
                <app-input
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  :radio-checkbox-name="field.name"
                  type="checkbox"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'select'">
                <app-input
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  type="select"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'number'">
                <app-input v-model="customFieldValue[field.name]" type="number" />
              </template>
              <template v-if="field.custom_field_type.name === 'date'">
                <app-input v-model="customFieldValue[field.name]" type="date" />
              </template>
            </div>
          </div>
        </template>
        <!-- ------------------------------------------------------------- -->
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            Procedencia
          </label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.procedencia"
              :list="procedenciaList"
              :required="true"
              type="select"
              :error-message="$errorMessage(errors, 'pipeline_id')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center"></label>
          <div class="col-sm-9" v-if="formData.procedencia==='Otro'">
            <app-input
              v-model="formData.procedencia_otro"
              placeholder="Ingrese otra procedencia"
              type="text"
              :error-message="$errorMessage(errors, 'title')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            Ultimo seguimiento
          </label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.last_follow_up"
              placeholder="Seleccionar fecha"
              :required="true"
              :popover-position="'top-start'"
              type="date"
              :error-message="$errorMessage(errors, 'expired_at')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            Tipo
          </label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.tipo"
              :list="tipoList"
              :required="true"
              type="select"
              :error-message="$errorMessage(errors, 'pipeline_id')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            Rubro
          </label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.rubro"
              :required="true"
              placeholder="Ingrese el rubro"
              type="text"
              :error-message="$errorMessage(errors, 'title')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            Servicios
          </label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.servicios"
              placeholder="Seleccione los servicios"
              :required="true"
              type="multi-select"
              
              :error-message="$errorMessage(errors, 'title')"
              :list="[
                {id:'Social media', value: 'Social media'},
                {id:'Branding', value: 'Branding'},
                {id:'Software', value: 'Software'},
                {id:'Contenido', value: 'Contenido'},
                {id:'Otro', value: 'Otro'},
              ]"
            />
          </div>
        </div>
        <div class="form-group row" v-if="formData.servicios">
          <label class="mb-0 col-sm-3 d-flex align-items-center"></label>
          <div class="col-sm-9" v-if="formData.servicios.includes('Otro')">
            <app-input
              v-model="formData.servicio_otro"
              placeholder="Ingrese otro servicio"
              type="text"
              :error-message="$errorMessage(errors, 'title')"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="mb-0 col-sm-3 d-flex align-items-center">
            Temperatura
          </label>
          <div class="col-sm-9">
            <app-input
              v-model="formData.temperatura"
              :list="temperatureList"
              :required="true"
              type="select"
              :error-message="$errorMessage(errors, 'pipeline_id')"
            />
          </div>
        </div>
        <!-- ------------------------------------------------------------- -->
      </form>
      <app-overlay-loader v-else />
    </template>
    <template slot="footer">
      <button
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        type="button"
        @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button class="btn btn-primary" type="button" @click.prevent="submit">
        <span v-if="loading" class="w-100">
          <app-submit-button-loader></app-submit-button-loader>
        </span>
        <template v-else>{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>
import { FormMixin } from "@core/mixins/form/FormMixin";
import { api } from "@app/Helpers/api";
import { collect } from "@app/Helpers/Collection";
import { mapGetters } from "vuex";
import { getAllCustomFields } from "@app/Mixins/Global/CustomFieldMixin";
import {axiosGet} from "../../../Helpers/AxiosHelper";

export default {
  name: "DealModal",
  mixins: [FormMixin, getAllCustomFields],
  props: {
    preSelectedOption: Object,
    selectedUrl: String,
    tableId: String,
    pipelineId: Number,
    selectedStageIndex: Number,
    componentType: {
      type: String,
      default: "deal",
    },
    selectedUrlId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      route,
      formData: {
        tax_id: null,
        owner_id: user.id,
        pipeline_id: this.pipelineId,
        lead_type: this.componentType == "org" ? 2 : 1,
        contextable_id: this.selectedUrlId ?? null,
        //////////////////////////
        procedencia: null,
        procedencia_otro: '',
        last_follow_up: null,
        tipo_id: null,
        rubro: '',
        servicios: [],
        servicio_otro:'',
        temperature_id: null,
      },
      contactPersonListLength: 0,
      addEditData: {},
      contactTypeList: [],
      pipelineList: [],
      stageList: [],
      stageId: {},
      errors: [],
      dataLoaded: false,
      loading: false,
      pipelineChange: true,
      renderContextableInput: true,
      customFieldValue: [],
      contactPersonList: [],
      personsOptions: {
          url: route('selectable.persons'),
          query_name: "name", // by default 'search'
          per_page: 10, // must need to set min 10 per page for showing scrollbar
          modifire: (item) => {
              return { id: item.id, value: item.name }
          },
          params: {},
          loader: "app-pre-loader" // by default 'app-overlay-loader'
      },

      organizationOptions: {
          url: route('selectable.organisations'),
          query_name: "name", // by default 'search'
          per_page: 10, // must need to set min 10 per page for showing scrollbar
          modifire: (item) => {
              return { id: item.id, value: item.name }
          },
          params: {},
          loader: "app-pre-loader" // by default 'app-overlay-loader'
      },
      // personListAsOrgOptios: {
      //     // url: route('selectable.organization_owners',{id: this.formData.contextable_id}),
      //     url: route('selectable.organization_owners',{id: 118}),
      //     query_name: "name", // by default 'search'
      //     per_page: 10, // must need to set min 10 per page for showing scrollbar
      //     modifire: (item) => {
      //         return { id: item.id, value: item.name }
      //     },
      //     params: {},
      //     loader: "app-pre-loader", // by default 'app-overlay-loader'
      //     listValueField:'name'
      // },
      procedenciaList: [
          { id: "Referido", value: "Referido" },
          { id: "Redes sociales/llamada", value: "Redes sociales/llamada" },
          { id: "Prospectado", value: "Prospectado"},
          { id: "Otro", value: "Otro"}
      ],
      tipoList:[
          { id: "Empresa", value: "Empresa" },
          { id: "Emprendimiento", value: "Emprendimiento" },
          { id: "Proyecto", value: "Proyecto"}
      ],
      temperatureList:[
          { id: 'Frio', value: 'Frio' },
          { id: 'Tibio', value: 'Tibio' },
          { id: 'Caliente' , value: 'Caliente' },
      ]
    };
  },
  computed: {
      personListAsOrgOptios() {
        return  {
            url: route('selectable.organization_owners', {id: this.formData.contextable_id}),
            query_name: "name", // by default 'search'
            per_page: 10, // must need to set min 10 per page for showing scrollbar
            params: {},
            loader: "app-pre-loader", // by default 'app-overlay-loader'
            listValueField:'name',
            modifire: (item) => {
                this.contactPersonList.push(item);
                return { id: item.id, value: item.name }
            },
        }
      },
    // personListAsOrg() {
    //   return this.personList.filter((item) =>
    //     item.organizations.find((el) => el.id == this.formData.contextable_id)
    //   );
    // },
    stageListAsPipelineId() {
      this.loadStepInput();
      return this.stageList.filter((v) => v.pipeline_id == this.formData.pipeline_id);
    },
    stageIndexAsId() {
      let index = undefined;
      let stageListByPipeLine = this.stageList.filter(
        (v) => v.pipeline_id == this.formData.pipeline_id
      );
      for (let i = 0; i < stageListByPipeLine.length; i++) {
        if (stageListByPipeLine[i].id === this.formData.stage_id) {
          index = i;
        }
      }
      return index;
    },

    ...mapGetters({
      ownerList: "getOwner",
      organizationList: "getOrganization",
      personList: "getPerson",
      dealList: "getDeal",
    }),
  },
  created() {
    //preSelectedOption are set in here
    if (this.preSelectedOption) {
      if (this.preSelectedOption.organization_id) {
        this.formData.organization_id = this.preSelectedOption.organization_id;
      }
      if (this.preSelectedOption.person_id) {
        this.formData.person_id = this.preSelectedOption.person_id;
      }
    }
    //end of preSelectedOption set
    this.getPipeline();
    this.getStages();
    if (!this.selectedUrl) {
      this.getAllCustomFields("deal");
    }
    this.$nextTick(() => {
      if (this.$props.selectedStageIndex != undefined) {
        this.formData.stage_id = this.$props.selectedStageIndex;
      }
    });
  },
  methods: {
      handleListChange(newLength) {
          this.contactPersonListLength = newLength;
      },
      handleOrgPersonChange(){
          this.contactPersonList = [];
      },
    loadStepInput() {
      this.pipelineChange = false;
      this.$nextTick(() => {
        this.pipelineChange = true;
      });
    },
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
      let customData = [];
      this.customFields.map((el) => {
        let item = {
          value:
            el.custom_field_type.name == "checkbox"
              ? el.meta.split(",").filter((e, i) => {
                  if (
                    this.customFieldValue[el.name].includes(String(i)) ||
                    this.customFieldValue[el.name].includes(i)
                  ) {
                    return e;
                  }
                })
              : el.custom_field_type.name == "select" ||
                el.custom_field_type.name == "radio"
              ? el.meta.split(",").find((e, i) => {
                  return i == Number(this.customFieldValue[el.name]);
                })
              : this.customFieldValue[el.name],
          custom_field_id: el.id,
        };
        customData.push(item);
      });
      this.addEditData.person_id = this.formData.person_id;
      if (this.formData.lead_type == 1) {
        this.addEditData.person_id = this.formData.contextable_id;
      }
      this.addEditData.customs = customData;
      this.addEditData.title = this.formData.title;
      this.addEditData.description = this.formData.description;
      this.addEditData.lead_type = this.formData.lead_type;
      this.addEditData.contextable_id = this.formData.contextable_id;
      this.addEditData.value = this.formData.value;
      this.addEditData.pipeline_id = this.formData.pipeline_id;
      this.addEditData.stage_id = this.formData.stage_id;
      this.addEditData.owner_id = this.formData.owner_id;
      this.addEditData.tax_id = this.formData.tax_id;

      this.addEditData.expired_at = this.formData.expired_at
        ? moment(this.formData.expired_at).format("YYYY-MM-DD HH:mm:ss")
        : null;
      //////////////////////////////////////////////////////////////////////////////
      this.addEditData.procedencia = this.formData.procedencia;
      this.addEditData.procedencia_otro = this.formData.procedencia_otro 
      ? this.formData.procedencia_otro.length > 0 
        ? this.formData.procedencia_otro 
        : null
      : null; 
      this.addEditData.last_follow_up = this.formData.last_follow_up
        ? moment(this.formData.last_follow_up).format("YYYY-MM-DD HH:mm:ss")
        : null;
      this.addEditData.tipo = this.formData.tipo;
      this.addEditData.rubro = this.formData.rubro;
      this.addEditData.servicios = JSON.stringify(this.formData.servicios);
      this.addEditData.servicio_otro = this.formData.servicio_otro
      ? this.formData.servicio_otro.length > 0 
        ? this.formData.servicio_otro 
        : null
      : null;
      this.addEditData.temperatura = this.formData.temperatura;
      console.log(this.addEditData);

      this.axiosGet(
        route(`statuses.index`, { _query: { name: "status_open", type: "deal" } })
      ).then((response) => {
        this.addEditData.status_id =
          this.formData.status_id ?? collect(response.data).first().id;
        this.save(this.addEditData);
      });
    },
    afterError(response) {
      this.loading = false;
      this.errors = response.data.errors;
    },
    afterSuccess(response) {
      this.$store.dispatch("getDeal");
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      this.$emit("saved");
      this.$hub.$emit("deal-update-list");
      this.closeModal();
    },
    afterFinalResponse() {
      this.loading = false;
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
      this.formData.servicios = JSON.parse(response.data.servicios);
      this.getAllCustomFields("deal");
      // this.formData.person_id = this.formData.contact_person[0].id;
      this.formData = {
        person_id: response.data.contact_person[0].id,
      };
      this.formData = {
        ...this.formData,
        ...response.data,
      };
      let expired_at = response.data.expired_at.split(" ");
      this.formData.expired_at = new Date(expired_at);
    },
    closeModal(value) {
      this.$emit("close-modal", value);
    },
    getPipeline() {
      this.axiosGet(route("pipelines.index"))
        .then((response) => {
          this.pipelineList = this.collection(response.data.data).shaper("name");
          if (!this.formData.pipeline_id) {
            this.formData.pipeline_id = response.data.data[0].id;
          }
        })
        .catch(({ error }) => {});
    },
    getStages() {
      this.axiosGet(route("stages.index", { _query: { all: true } }))
        .then((response) => {
          this.stageList = collect(response.data)
            .where("pipeline_id", this.formData.pipeline_id)
            .sortBy("priority")
            .get();
          this.stageId = this.stageList.find(
            (v) => v.pipeline_id == this.formData.pipeline_id
          );

          //this.dataLoaded = true;
        })
        .catch(({ error }) => {});
    },
    setStageId(index) {
      if (this.stageListAsPipelineId.length) {
        this.formData.stage_id = this.stageListAsPipelineId[index].id;
      }
    },
    changeLeadType() {
      this.formData.contextable_id = null;
      this.renderContextableInput = false;
      setTimeout(() => {
          this.renderContextableInput = true;
      }, 100)
    },
  },
  watch:{
    'formData.procedencia_id': function (val) {
      if(val === '4'){
        this.formData.procedencia_text = '';
      }
    },
    'formData.servicios': function (val) {
      if(!val) return;
      if(!val.includes('Otro')){
        this.formData.servicios_otro = '';
      }
    }
  }
};
</script>
